import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import { apiInclude } from '../utils';

// Sem firstPost/lastPost: o ThreadCard lê resumo, curtidas e a última resposta
// de atributos da discussão, e incluir os posts custava o render do s9e de dois
// posts inteiros por card.
const FEED_INCLUDE = () => apiInclude('user', 'lastPostedUser', 'tags');

/**
 * `DiscussionListState` com o que os feeds em tempo real do tema precisam:
 * discussões que chegaram pelo WebSocket esperando o banner (`pendingDiscs`),
 * ids destacados como novos (`newDiscIds`), likes do próprio usuário para calar
 * o eco do realtime (`selfActionIds`), likes remotos (`updatedLikeIds`) e falhas
 * de refetch que o banner ainda conta (`wsFetchFailures`).
 */
export default class DiscussionFeedState extends DiscussionListState {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "pendingDiscs", new Map());
    _defineProperty(this, "newDiscIds", new Set());
    _defineProperty(this, "selfActionIds", new Set());
    _defineProperty(this, "updatedLikeIds", new Set());
    _defineProperty(this, "wsFetchFailures", 0);
  }
  /** Garante as relações que o ThreadCard exige, seja qual for o feed. */
  requestParams() {
    const params = super.requestParams();
    return {
      ...params,
      include: FEED_INCLUDE()
    };
  }

  /**
   * Discussões de todas as páginas carregadas, fixadas no topo. A view itera isto,
   * não `getPages()`.
   */
  flatItems() {
    const flat = [];
    this.getPages().forEach(page => {
      const items = Array.isArray(page.items) ? page.items : page.items.data || [];
      items.forEach(d => d && flat.push(d));
    });
    flat.sort((a, b) => (b.isSticky?.() ? 1 : 0) - (a.isSticky?.() ? 1 : 0));
    return flat;
  }

  /**
   * Passa as chegadas pendentes para o feed: cada uma entra no topo por
   * `addDiscussion` (que deduplica) e fica marcada como nova por ~4s.
   */
  flushPending() {
    const pending = Array.from(this.pendingDiscs.values());
    this.pendingDiscs.clear();
    this.wsFetchFailures = 0;
    pending.forEach(disc => {
      const id = String(disc.id?.() || '');
      this.addDiscussion(disc);
      this.newDiscIds.add(id);
    });
    m.redraw();
    setTimeout(() => {
      this.newDiscIds.clear();
      m.redraw();
    }, 4000);
  }

  /** Número mostrado no banner do WS. */
  pendingCount() {
    return this.pendingDiscs.size + this.wsFetchFailures;
  }
  isEmptyResult() {
    return !this.isInitialLoading() && !this.hasItems();
  }
}
flarum.reg.add('ramon-avocado', 'forum/states/DiscussionFeedState', DiscussionFeedState);